import {
    CLIENT_FEEDBACK_REQUEST,
    CLIENT_FEEDBACK_SUCCESS,
    CLIENT_FEEDBACK_FAILURE,
    CLIENT_FEEDBACK_RESET,
  } from "../../actions/types";
  
  // reducer.js
  const initialState = {
    isLoading: false,
    response: null,
    error: null,
  };
  
  export const ClientFeedbackReducer = (state = initialState, action) => {
    switch (action.type) {
      case CLIENT_FEEDBACK_REQUEST:
        return { ...state, isLoading: true, response: null, error: null };
      case CLIENT_FEEDBACK_SUCCESS:
        return {
          ...state,
          isLoading: false,
          response: action.payload,
          error: null,
        };
      case CLIENT_FEEDBACK_FAILURE:
        return {
          ...state,
          isLoading: false,
          response: null,
          error: action.payload,
        };
      case CLIENT_FEEDBACK_RESET:
          return {
            ...state,
            isLoading: false,
            response: null,
            error: null,
          };
      default:
        return state;
    }
  };
  